export const leadAnalystParser = ({
  analystTeams,
  firstName,
  followed,
  id,
  jobFunction,
  jobTitle,
  name,
}) => ({
  analystTeams,
  firstName,
  lastName: name,
  followed,
  userId: id,
  jobFunction,
  jobTitle,
});
